'use client'
import { getLiked } from '@/helpers/Functions/liked';
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { Product } from '@/types';

interface LikedContextType {
    liked: Product[];
    setLiked: React.Dispatch<React.SetStateAction<Product[]>>;
}

const LikedContext = createContext<LikedContextType | undefined>(undefined);

export const useLiked = () => {
    const context = useContext(LikedContext);
    if (!context) {
        throw new Error('useLiked must be used within a LikedProvider');
    }
    return context;
};

interface LikedProviderProps {
    children: ReactNode;
}


export const LikedProvider: React.FC<LikedProviderProps> = ({ children }) => {
    const [liked, setLiked] = useState<Product[]>([]);

    useEffect(() => {
        if (typeof window !== 'undefined' && window !== null) {
            getLiked(setLiked);
        }
    }, [])

    return (
        <LikedContext.Provider value={{ liked, setLiked }}>
            {children}
        </LikedContext.Provider>
    );
};
